const tokens = {
  colors: {
    'bg-canvas': {
      default: 'gray.50',
      _dark: 'gray.900',
    },
    'bg-surface': {
      default: 'white',
      _dark: 'gray.800',
    },
    'bg-subtle': {
      default: 'gray.50',
      _dark: 'gray.700',
    },
    'bg-muted': {
      default: 'gray.100',
      _dark: 'gray.700',
    },
    default: {
      default: 'gray.800',
      _dark: 'gray.200',
    },
    inverted: {
      default: 'gray.200',
      _dark: 'gray.800',
    },
    emphasized: {
      default: 'gray.900',
      _dark: 'gray.100',
    },
    muted: {
      default: 'gray.600',
      _dark: 'gray.300',
    },
    subtle: {
      default: 'gray.500',
      _dark: 'gray.400',
    },
    subdued: {
      default: 'gray.400',
      _dark: 'gray.500',
    },
    border: {
      default: 'gray.200',
      _dark: 'gray.700',
    },
    accent: {
      default: 'brand.500',
      _dark: 'brand.400',
    },
    'accent-subdued': {
      default: 'brand.800',
      _dark: 'brand.200',
    },
    success: {
      default: 'green.600',
      _dark: 'green.500',
    },
    error: {
      default: 'red.600',
      _dark: 'red.500',
    },
    warning: {
      default: 'yellow.600',
      _dark: 'yellow.200',
    },
    'bg-accent': {
      default: 'brand.500',
      _dark: 'brand.500',
    },
    'bg-accent-subtle': {
      default: 'brand.300',
      _dark: 'brand.700',
    },
    'bg-accent-subdued': {
      default: 'brand.100',
      _dark: 'brand.900',
    },
    'bg-accent-muted': 'brand.400',
    'on-accent': 'white',
    'on-accent-muted': 'brand.50',
    'on-accent-subtle': 'brand.100',
  },
}

export default tokens
